import { PageScaffold } from "../../shared/ui/PageScaffold";

export function ContactSettingsPage() {
  return (
    <PageScaffold
      title="Contact Settings"
      description="連絡先設定画面のプレースホルダーです。"
    >
      <p>ここに verified email と通知設定の UI を実装します。</p>
    </PageScaffold>
  );
}
